// Styles
import "./header.scss";
// Components
import { StatusChip } from "../../../../shared/components/status-chip/StatusChip";
import { CompactButton } from "../../../../shared/components/buttons/compact-button/CompactButton";
import { InterfaceSwitcher } from "./components/InterfaceSwitcher/InterfaceSwitcher";
import { CircleLoader } from "../../../../shared/components/circle-loader/CircleLoader";
import { UpdateTime } from "./components/update-time/UpdateTime";
import { SocketStatus } from "./components/socket-status/SocketStatus";
// Service
import { useDashboardData } from "../../service/dashboard-data.service";
import { HelloModal } from "./components/hello-modal/HelloModal";
import { HeaderModals } from "./HeaderModals";
import { useHeaderModals } from "./useHeaderModals";

export const Header = () => {
	const { data, isAwaitingDashboardContent } = useDashboardData();
	const modals = useHeaderModals();

	return (
		<div className='header'>
			<div className='header__wrapper'>
				{!isAwaitingDashboardContent ? (
					<div className='header__wrapper-left header-left'>
						<div className='header-left__user'>
							{data?.mcc_account?.data?.account_name ? (
								<img
									src='/img/icons/user.png'
									alt='user icon'
									className='header-left__user-image'
								/>
							) : (
								<img
									src='/img/icons/person-off.png'
									alt='person off icon'
									className='header-left__user-image'
								/>
							)}
							<div className='header-left__user-name'>
								{data?.mcc_account?.data?.account_name ? (
									<span
										data-copyable
										title='Натисніть, щоб скопіювати'>
										{data.mcc_account.data.account_name}
									</span>
								) : null}
								{data?.mcc_account?.data?.account_id ? (
									<span>
										(
										<span
											data-copyable
											title='Натисніть, щоб скопіювати ID'>
											{data.mcc_account.data.account_id}
										</span>
										)
									</span>
								) : (
									<span>Немає даних про акаунт</span>
								)}
							</div>
						</div>
						<div className='header-left__info'>
							{data?.mcc_account?.data?.is_mcc ? (
								<div className='header-left__profile-status'>
									<StatusChip status={`${data?.mcc_account?.data?.status}`} />
								</div>
							) : null}
							{data?.mcc_account?.data?.status ? <UpdateTime /> : null}
						</div>
					</div>
				) : (
					<div className='header-left__loader-wrapper'>
						<CircleLoader size='small' />
						<div>Завантаження</div>
					</div>
				)}
				<div className='header__wrapper-right header-right'>
					<SocketStatus />
					<InterfaceSwitcher />
					{data?.mcc_account?.data?.account_name ? (
						<CompactButton
							onClick={() => void modals.openReport()}
							type={"button"}
							theme={"default"}
							title='Створити звіт'
							className='header-right__responsive'
							iconLeft={<img src='/img/icons/report.png' alt='report icon' />}>
							Створити звіт
						</CompactButton>
					) : null}
					<CompactButton
						onClick={() => void modals.openDocs()}
						type={"button"}
						theme={"default"}
						title='Документація'
						className='header-right__responsive'
						iconLeft={<img src='/img/icons/book.png' alt='book icon' />}>
						Документація
					</CompactButton>
					{data?.mcc_account?.data?.account_name ? (
						<CompactButton
							onClick={() => void modals.openSettings()}
							type={"button"}
							theme={"default"}
							title='Налаштування'
							className='header-right__responsive'
							iconLeft={
								<img src='/img/icons/settings.png' alt='documentation icon' />
							}>
							Налаштування
						</CompactButton>
					) : null}
					<CompactButton
						onClick={() => modals.openLogoutConfirm()}
						type={"button"}
						theme={"red"}
						title='Вихід'
						className='header-right__responsive'
						iconLeft={<img src='/img/icons/exit.png' alt='exit icon' />}>
						Вихід
					</CompactButton>
				</div>
			</div>
			<HelloModal onOpenDocs={modals.openDocs} />
			<HeaderModals
				// docs
				isDocsOpen={modals.isDocsOpen}
				isDocsLoading={modals.isDocsLoading}
				docsError={modals.docsError}
				docsSafeHtml={modals.docsSafeHtml}
				onCloseDocs={modals.closeDocs}
				// report
				isReportOpen={modals.isReportOpen}
				isReportLoading={modals.isReportLoading}
				reportInfo={modals.reportInfo}
				reportError={modals.reportError}
				onCloseReport={modals.closeReport}
				onDownloadReport={modals.downloadReport}
				formatFileSize={modals.formatFileSize}
				formatDateTime={modals.formatDateTime}
				// settings
				isSettingsOpen={modals.isSettingsOpen}
				isSettingsLoading={modals.isSettingsLoading}
				isSettingsApplying={modals.isSettingsApplying}
				isSettingsApplyDisabled={modals.isSettingsApplyDisabled}
				buyerPreferencesLoaded={modals.buyerPreferencesLoaded}
				settingsError={modals.settingsError}
				autoAcceptApps={modals.autoAcceptApps}
				autoOverwriteCert={modals.autoOverwriteCert}
				settingsLastUpdatedAt={modals.settingsLastUpdatedAt}
				isChatConnected={modals.isChatConnected}
				userPromptDraft={modals.userPromptDraft}
				userPromptError={modals.userPromptError}
				onCloseSettings={modals.closeSettings}
				onAutoAcceptAppsDraftChange={modals.setAutoAcceptAppsDraft}
				onAutoOverwriteCertDraftChange={modals.setAutoOverwriteCertDraft}
				onUserPromptDraftChange={modals.setUserPromptDraftValue}
				onApplySettings={modals.applySettings}
				// auth error
				isAuthErrorOpen={modals.isAuthErrorOpen}
				onCloseAuthError={modals.closeAuthError}
				// logout confirm
				isLogoutConfirmOpen={modals.isLogoutConfirmOpen}
				isLogoutLoading={modals.isLogoutLoading}
				logoutError={modals.logoutError}
				onCloseLogoutConfirm={modals.closeLogoutConfirm}
				onConfirmLogout={modals.confirmLogout}
			/>
		</div>
	);
};

// "mcc_account": {
// 	"version": 1,
// 	"fetched_at": 1778245243,
// 	"data": {
// 			"account_name": "Happy Gilmore",
// 			"account_id": "991-100-6294",
// 			"status": "ENABLED",
// 			"is_mcc": true
// 	}
// },
